import { useEffect, useState } from "react";
import { getNewsByFilter } from "../api/apiHandler";

/**
 * Reusable news fetching hook
 * @param {Object} filters - { language, state, category, limit }
 */
const useNews = (filters = {}) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    setLoading(true);
    setError(null);

    getNewsByFilter(filters)
      .then((res) => {
        if (!isMounted) return;
        setNews(res?.data || []);
      })
      .catch((err) => {
        if (!isMounted) return;
        setError(err);
        console.error("useNews error:", err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false; // prevent memory leaks
    };
  }, [JSON.stringify(filters)]); // stable dependency

  return { news, loading, error };
};

export default useNews;
